import { Controller } from "@hotwired/stimulus"

// Lógica interativa do formulário de contrato (AC):
//  - habilita/desabilita os campos de desconto inicial conforme o select
//  - espelha o nº de dias do desconto nos textos .dias_desconto_inicial
//  - mostra/esconde blocos .produto-* e .valor-* conforme produto e tipo de crédito
//  - carrega o conteúdo de um modelo de contrato no CKEditor ao trocar o tipo
// Seletores por classe/id escopados ao form (espelham o jQuery original).
// O estado inicial de produto vem de produto-inicial-value (= @contrato.produto_id),
// igual ao bloco ERB original; o de tipo de crédito vem do valor do select.
export default class extends Controller {
  static values = { produtoInicial: String }

  connect() {
    this._mirrorDias()
    this._applyProduto(this.produtoInicialValue)
    const tc = this._byId("contrato_tipo_credito")
    if (tc) this._applyTipoCredito(tc.value, false)
  }

  toggleDesconto(event) {
    const enabled = event.target.value === "true"
    const dias = this._byId("contrato_dias_desconto_inicial")
    const taxa = this._byId("contrato_valor_taxa_desconto_inicial")
    if (dias) dias.disabled = !enabled
    if (taxa) taxa.disabled = !enabled
  }

  mirrorDias() {
    this._mirrorDias()
  }

  toggleProduto(event) {
    this._applyProduto(event.target.value)
  }

  toggleTipoCredito(event) {
    this._applyTipoCredito(event.target.value, true)
  }

  loadModelo(event) {
    const modeloId = event.target.value
    fetch(`/ac/contrato_modelos/${modeloId}?modo=carregar`, { headers: { Accept: "text/html" } })
      .then((r) => r.text())
      .then((data) => {
        const editor = typeof CKEDITOR !== "undefined" && CKEDITOR.instances["contrato_conteudo"]
        if (editor) editor.setData(data)
      })
  }

  _mirrorDias() {
    const dias = this._byId("contrato_dias_desconto_inicial")
    const val = dias ? dias.value : ""
    this.element.querySelectorAll(".dias_desconto_inicial").forEach((el) => { el.textContent = val })
  }

  _applyProduto(produtoId) {
    if (produtoId === "1") { // convênio
      this._show(".produto-associado", true)
      this._show(".produto-combustivel", true)
      this._show(".produto-acumular-credito", true)
    } else if (produtoId === "3") { // combustível
      this._show(".produto-associado", false)
      this._show(".produto-combustivel", true)
      this._show(".produto-acumular-credito", true)
      this._show(".valor-litros", false)
    } else if (produtoId === "5" || produtoId === "6") { // manutenção, saúde
      this._show(".produto-associado", false)
      this._show(".produto-combustivel", false)
      this._show(".produto-acumular-credito", false)
    } else { // demais
      this._show(".produto-associado", true)
      this._show(".produto-combustivel", false)
      this._show(".produto-acumular-credito", true)
    }
  }

  _applyTipoCredito(tipo, fromChange) {
    if (!fromChange) {
      // estado inicial: espelha os dois ifs independentes do original
      if (tipo === "DINHEIRO") this._show(".valor-litros", false)
      if (tipo === "LITROS") this._show(".valor-dinheiro", false)
      return
    }
    if (tipo === "LITROS") {
      this._show(".valor-dinheiro", false)
      this._show(".valor-litros", true)
    } else {
      this._show(".valor-dinheiro", true)
      this._show(".valor-litros", false)
    }
  }

  _byId(id) {
    return this.element.querySelector(`#${id}`)
  }

  _show(selector, show) {
    this.element.querySelectorAll(selector).forEach((el) => { el.style.display = show ? "" : "none" })
  }
}
